export const PRODUCT_REVIEW_API_URL = {
  createProductReview: "/v1/product-review",
};
